import React, { useContext, useEffect, useState } from 'react'
import { MdFamilyRestroom, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { IoMdClose } from 'react-icons/io';
import { AiOutlineSearch, AiOutlineTags } from 'react-icons/ai'
import { MdFilterListAlt } from "react-icons/md";
import Renderif from '../../components/renderif';
import { PsicoSideMenu } from '../../components/sidemenu';
import { gray30, gray40 } from '../../utils/colors';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { AuthContext } from '../../context/auth_context';
import { Service } from '../../services/api';
import TipCard from '../../components/tipcard';
import CheckBox from '../../components/checkbox';
import { FaHandshake } from 'react-icons/fa';

export default function TipsPsico() {

  const { user } = useContext(AuthContext);

  const [state, setState] = useState({
    tab: 0,
    show_agendar_cita: false,
    show_onboarding: user.onboarding === "" || user.onboarding === null ? true : false,
    tips: [],
    tip_selected: null,
    search: ''
  })

  useEffect(() => {
    const init = async () => {
      let tips = await Service('GET', `Tip?pageNumber=1&pageSize=20`);
      setState({ ...state, tips: tips.data.data })
    };
    init();

    return () => { }
  }, [])

  const init = async () => {
    let tips = await Service('GET', `Tip?pageNumber=1&pageSize=20`);
    setState({ ...state, tips: tips.data.data })
  }



  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  const getVideo = (link) => {
    let video = 'https://www.youtube.com/watch?v=S8nTuZR059k';
    const urlSearchParams = new URLSearchParams(video);
    const params = Object.fromEntries(urlSearchParams.entries());

    let v = getParameterByName('v', link)
    return v
  }

  const filter = (tips) => {

    let filtered = tips.filter((item) =>
      item.description.toUpperCase().includes(state.search.toUpperCase()) ||
      item.title.toUpperCase().includes(state.search.toUpperCase())

    )


    return filtered
  }

  const onDeleteTip = async () => {
    console.log(state.tip_selected)

    let _delete = await Service('DELETE', `Tip/${state.tip_selected.id}`);
    console.log(_delete)
    if (_delete.status === 200) {
      state.tip_selected = null;
      init();
    }
  }


  return (
    <div className='container-fluid d-flex h-100'>

      <PsicoSideMenu></PsicoSideMenu>

      <div className='container-fluid d-flex flex-column  h-100'>

        <div className='d-flex flex-column flex-lg-row  bg-light p-2 p-sm-3 '>
          <div className='d-flex align-items-center'>
            <div className='text-dark f-28 bold line-0'>Tips</div>
          </div>
          <div className='col'></div>
          <div className='col d-flex flex-column flex-sm-row align-items-sm-center'>

            <div className='input--light order-1 order-sm-0'>
              <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
              <input className='bg-transparent' placeholder='Busca Tips, Documentos ...' value={state.search} onChange={(evt) => {
                setState({ ...state, search: evt.currentTarget.value })
              }}></input>
            </div>

            <div className='d-flex py-1 py-sm-2 order-0 order-sm-1'>



              <div className='pe-2 px-sm-2'>
                <div className='bv-cta bv-cta--outline'><MdFamilyRestroom size={29} color={gray30}></MdFamilyRestroom></div>
              </div>
              <div className='pe-2'>
                {/* <div className='bv-cta bv-cta--outline'><SiHandshake size={24} color={gray30}></SiHandshake></div> */}
                <DropDown

                  title={''}
                  icon={<FaHandshake size={24} color={gray30}></FaHandshake>}>

                  <DropDownOption disabled>
                    <div className='d-flex align-items-center px-2'>

                      <div className='text-dark f-16 bold'>Acuerdos</div>

                      <div className='col mx-5'></div>

                      <div className='cursor-pointer text-decoration-underline text-primary bold f-14 prevent-select'>Ver Más</div>

                    </div>
                  </DropDownOption>


                  {/* <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 3</div>
                                      <div className='text-gray f-12'>10 octubre 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                          <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 2</div>
                                      <div className='text-gray f-12'>2 octubre 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                          <DropDownOption>
                              <div className='d-flex align-items-center ps-2'>
                                  <div>
                                      <div className='text-dark f-14 bold'>Sesion 1</div>
                                      <div className='text-gray f-12'>23 Sept. 2023</div>
                                  </div>
                                  <div className='col'></div>
                                  <div className='ms-5'>
                                      <div className='bv-icon bv-icon--mid'>
                                          <MdOutlineKeyboardArrowRight size={26} color={gray30}></MdOutlineKeyboardArrowRight>
                                      </div>
                                  </div>
                              </div>
                          </DropDownOption>
                       */}



                </DropDown>
              </div>



              {/* <div className=''>
                <div className='bv-cta bv-cta--primary' onClick={() => {
                  setState({ ...state, show_agendar_cita: true })
                }}>
                  Agendar Cita
                </div>
              </div> */}




            </div>



          </div>
        </div>



        <div className='col h-75 d-flex '>

          <div className='col-3 overflow-auto hide-scroll bg-light px-4 '>

            <div className='d-flex align-items-center bg-white r-10 p-2'>
              <div className='f-16 text-gray'></div>
              <div className='col'></div>
              <DropDown
                title={''}
                icon={<MdFilterListAlt size={20} color={gray30}></MdFilterListAlt>}>

                <DropDownOption>
                  <div className='d-flex align-items-center px-2'>



                    <div className='text-dark f-16 bold'>Filtro</div>

                    <div className='col mx-5'></div>

                    <div className='bv-icon'><IoMdClose size={16} color={gray40}></IoMdClose></div>

                  </div>
                </DropDownOption>
                <DropDownOption disabled>
                  <div className='d-flex flex-column ps-2'>
                    <CheckBox checked={true} text="Asignados"></CheckBox>
                    <CheckBox checked={true} text="Nuevo"></CheckBox>
                    <CheckBox checked={true} text="Fecha Ascendente"></CheckBox>
                    <CheckBox checked={true} text="Fecha Descendente"></CheckBox>

                  </div>
                </DropDownOption>
                <DropDownOption>
                  <div className='d-flex align-items-center ps-2'>
                    <div className='col'></div>
                    <div className='f-14  bold text-blue'> Aplicar filtro</div>
                    <div className='bv-icon'><MdOutlineKeyboardArrowRight color={gray40}></MdOutlineKeyboardArrowRight></div>
                  </div>
                </DropDownOption>

              </DropDown>
            </div>

            {
              filter(state.tips)?.map((item, i) => {
                if (item.id === '9c1c02e2-1ac6-42da-b6a9-9aae4af8e89c') { return }

                return (<TipCard tag="Nuevo" key={i} tip={item} onClick={() => {
                  setState({ ...state, tip_selected: item })
                }}></TipCard>)
              })
            }
            <div className='my-5 py-5'></div>

          </div>
          {/* <div className='col-1'></div> */}

          <div className='col-9 overflow-auto hide-scroll px-4 '>

            <div className='container'>


              <Renderif isTrue={state.tip_selected === null}>

                <div className='position-relative'>
                  <img width="100%" className='mx-auto' src='/assets/bannertips.png'></img>
                  <div className='position-absolute absolute-center-left ps-4 '>
                    <div className='f-30 bolder line-0'>Explora Nuestro Universo de <br></br> Bienestar y Psicología</div>
                    <br></br>
                    <div className='f-18'>En BienVivir, te ofrecemos una variedad de consejos y <br></br> recursos para fortalecer tu salud mental y tu bienestar. <br></br> Nuestra misión es brindarte herramientas valiosas para<br></br>  una vida más saludable y equilibrada.</div>
                  </div>
                </div>

              </Renderif>

              <Renderif isTrue={state.tip_selected !== null}>

                <div className='bv-card mt-4'>
                  <Renderif isTrue={state.tip_selected?.image !== null && getVideo(state.tip_selected?.video) === null}>
                    <div className='bv-card-img bv-card-img--full' style={{ backgroundImage: `url('${state.tip_selected?.image}')` }}></div>
                  </Renderif>

                  <Renderif isTrue={getVideo(state.tip_selected?.video) !== null}>
                    <iframe width="100%" height="415" src={`https://www.youtube.com/embed/${getVideo()}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                  </Renderif>

                  <div className='ps-2'>
                    <div className='f-16 bold text-gray p-1 pb-0 '>{state.tip_selected?.title}</div>
                    <div className='f-16 text-gray p-1'>{state.tip_selected?.description}</div>
                    <div className='my-5'></div>
                    <div className='d-flex align-items-end'>
                      <div className='f-12 bold text-blue p-1'>Tip #</div>
                      <div className='col'></div>
                      <div className={`text-white bg-purple bold f-12 px-3 py-1 my-1`}>¡Nuevo!</div>
                    </div>
                  </div>


                  <div className='px-2 py-2 d-flex align-items-end'>

                    <div className='bv-tag bv-tag--gray'>
                      <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                      <div className='text-gray pe-2'>Tip</div>
                    </div>

                    <div className='bv-tag bv-tag--gray'>
                      <div className='bv-icon'><AiOutlineTags></AiOutlineTags></div>
                      <div className='text-gray pe-2'>Bienvivir</div>
                    </div>
                    <div className='col'></div>
                    <div className='ps-2 text-red text-decoration-underline cursor-pointer f-12' onClick={() => {
                      onDeleteTip()
                    }}>Eliminar</div>
                  </div>
                </div>
              </Renderif>



              <div className='d-flex'>
                {/* <div className='col pe-3'> <TipCard tip={state.tips[0]} tag='Nuevo' ></TipCard></div>
                <div className='col pe-3'> <TipCard tip={state.tips[0]} tag='Nuevo' ></TipCard></div>
                <div className='col pe-3'> <TipCard tip={state.tips[0]} tag='Nuevo' ></TipCard></div>
                <div className='col'> <TipCard tip={state.tips[0]} tag='Nuevo' ></TipCard></div> */}
              </div>

            </div>

          </div>




        </div>






      </div>


    </div>
  )
}
